import React from 'react';
import { ModuleRouter } from '@tools/ui/types';
import InnerRouter from './InnerRouter';
import TabsNavigator from './TabsNavigator';

type IProps = {
  router: ModuleRouter;
  localeI18?: string;
  getTabAmount?: (tabName: string) => JSX.Element;
  tabBarExtraContent?: React.ReactNode;
  urlParam?: string;
};

const Module: React.FC<React.PropsWithChildren<IProps>> = ({
  router,
  localeI18,
  getTabAmount,
  tabBarExtraContent,
  urlParam
}: IProps) => {
  const visiblePages = router.pages.find((page) => !page.hideFromMenu);

  return (
    <>
      {!!visiblePages && (
        <TabsNavigator
          routes={router.pages}
          localeI18={localeI18}
          getTabAmount={getTabAmount}
          tabBarExtraContent={tabBarExtraContent}
          urlParam={urlParam}
        />
      )}
      <InnerRouter router={router} />
    </>
  );
};

export default Module;
